import * as React from 'react';

import { isExternalLink } from '@coursera-web/shared-articles';

import Imgix from 'js/components/Imgix';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import type { ArticlesImageLink } from 'bundles/unified-seo-content-common/__generated__/baseContentfulTypes';

export type Props = {
  configurableImage: Pick<ArticlesImageLink, 'link' | 'width'> & {
    url: string;
    description: string;
    title?: string | null;
  };
};

export const ConfigurableImage = ({ configurableImage }: Props) => {
  const resizedImg = (
    <figure>
      <Imgix
        src={configurableImage.url}
        alt={configurableImage.description}
        maxWidth={configurableImage.width || 1500}
        imgParams={{ quality: 60 }}
      />
      {configurableImage.title && <figcaption>{configurableImage.title}</figcaption>}
    </figure>
  );

  if (configurableImage.link) {
    return (
      <TrackedA
        href={configurableImage.link}
        target={isExternalLink(configurableImage.link) ? '_blank' : '_self'}
        rel={isExternalLink(configurableImage.link) ? 'noopener noreferrer' : ''}
        trackingName="article_image_link"
        data={{ imageTitle: configurableImage.title }}
      >
        {resizedImg}
      </TrackedA>
    );
  }

  return resizedImg;
};

export default ConfigurableImage;
